import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadComprobantesCompras } from '../../../store/slices/configuracionesSlice';
import ComprobantesConfigBody from './ComprobantesConfigBody';

const ComprobantesCompras = (props) => {
  const dispatch = useDispatch();
  const comprobantes = useSelector(state => state.configuraciones.comprobantesCompras.items);
  const loading = useSelector(state => state.configuraciones.comprobantesCompras.loading);
  const onLoad = (empresaId) => dispatch(loadComprobantesCompras(empresaId));
  const {
    empresaId,
    onChangeValue,
    configInicial,
    seleccionarTodos,
    deseleccionarTodos
  } = props;

  return (
    <ComprobantesConfigBody
      comprobantes={comprobantes}
      empresaId={empresaId}
      loading={loading}
      onChangeValue={onChangeValue}
      onLoad={onLoad}
      configInicial={configInicial}
      seleccionarTodos={seleccionarTodos}
      deseleccionarTodos={deseleccionarTodos}
    />
  );
};

export default ComprobantesCompras;